import { z } from 'zod';
import PriceRecommendationFeedbackVerdict from '../PriceRecommendationFeedbackVerdict';

export const priceRecommendationFeedbackSchema = z.object({
	companyHotelId: z.number(),
	stateId: z.number(),
	verdict: z.enum(PriceRecommendationFeedbackVerdict).optional(),
	comment: z.string(),
	suggestedPrice: z.number().finite().min(0).optional(),
}).superRefine((value, ctx) => {
	if (value.verdict === undefined && value.comment.trim() === '') {
		ctx.addIssue({
			code: z.ZodIssueCode.custom,
			message: 'Choose a verdict or write a comment.',
			path: ['comment'],
		});
	}
});
